// @flow
import { combineReducers } from 'redux';
import AwardReducer from 'modules/awards/reducer';
import CmsPagesReducer from 'modules/cmsPages/reducer';
import ProductBrowserReducer from './productBrowser/reducer';
import ProjectBrowserReducer from './projectBrowser/reducer';
import { EventReducer } from './event/reducer';
import { HomeReducer } from './home/reducer';
import { ProductReducer } from './product/reducer';
import { ProjectReducer } from './project/reducer';
import { RestaurantReducer } from 'modules/restaurant/reducer';
import TestimonialReducer from './testimonials/reducer';
import CmsDetailsReducer from './cmsDetails/reducer';
import TeamReducer from 'modules/team/reducer';
import type { EventState } from './event/reducer';
import type { HomeState } from './home/reducer';
import type { ProductState } from './product/reducer';
import type { ProjectState } from './project/reducer';
import type { RestaurantState } from 'modules/restaurant/reducer';
import { LocationReducer } from 'modules/location/reducer';
import type { LocationState } from 'modules/location/reducer';
import type { CareerState } from 'modules/careers/reducer';
import { CareerReducer } from 'modules/careers/reducer';
import { AboutReducer } from 'modules/about/reducer';
import CampaignPageReducer from 'modules/campaign/reducer';
import VideosReducer from 'modules/videos/reducer';
import type { ArchitectsState } from 'modules/shibaniKamalArchitecture/reducer';
import { ArchitectsReducer } from 'modules/shibaniKamalArchitecture/reducer';
import FooterLinkReducer from 'modules/footerLink/reducer';
import { RentalReducer } from 'modules/rentals/reducer';

// TODO: Define types instead of any
export type AppState = {
  event: EventState,
  home: HomeState,
  product: ProductState,
  project: ProjectState,
  restaurant: RestaurantState,
  productBrowser: any,
  CmsPagesReducer: any,
  projectBrowser: any,
  AwardReducer: any,
  TestimonialReducer: any,
  TeamReducer: any,
  CmsDetailsReducer: any,
  FooterLinkReducer: any,
  LocationReducer: LocationState,
  career: CareerState,
  AboutReducer: any,
  CampaignPageReducer: any,
  videos: any,
  architects: ArchitectsState,
};

const RootReducer: AppState = combineReducers({
  event: EventReducer,
  home: HomeReducer,
  product: ProductReducer,
  project: ProjectReducer,
  restaurant: RestaurantReducer,
  productBrowser: ProductBrowserReducer,
  CmsPagesReducer: CmsPagesReducer,
  projectBrowser: ProjectBrowserReducer,
  AwardReducer: AwardReducer,
  TestimonialReducer: TestimonialReducer,
  TeamReducer: TeamReducer,
  FooterLinkReducer: FooterLinkReducer,
  CmsDetailsReducer: CmsDetailsReducer,
  location: LocationReducer,
  career: CareerReducer,
  AboutReducer: AboutReducer,
  CampaignPageReducer: CampaignPageReducer,
  videos: VideosReducer,
  architects: ArchitectsReducer,
  rentals: RentalReducer,
  rentalFeature: RentalReducer,
});

export default RootReducer;
